import React, { useEffect, useRef, useState } from 'react';
import Moveable from 'react-moveable';
import '../../../css/Tools.scss';
import { createPortal } from 'react-dom';

function Reveal(props) {
  const targetRef = useRef();
  const [frame, setFrame] = useState({
    translate: [0, 0],
  });

  useEffect(() => {
    const revealTool = targetRef?.current;
    if (revealTool) {
      // Setting the max height dynamically to allow for reveal to cover full content on different screen sizes
      revealTool.style.maxHeight = `${revealTool.offsetHeight}px`;
    }
  }, []);

  return (
    createPortal(
      <div className='revealContainer'>
        <div ref={targetRef} className='revealTool' />
        <Moveable
          // edge={true}
          keepRatio={false}
          onResize={(e) => {
            const { beforeTranslate } = e.drag;

            setFrame({ translate: beforeTranslate });
            e.target.style.width = `${e.width}px`;
            e.target.style.height = `${e.height}px`;
            e.target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
          }}
          onResizeStart={(e) => {
            e.setOrigin(['%', '%']);
            e.dragStart && e.dragStart.set(frame.translate);
          }}
          origin={false}
          padding={{ left: 1, top: 20, right: 1, bottom: 1 }}
          renderDirections={['n']}
          resizable={true}
          target={targetRef}
          throttleResize={0}
          zoom={1}
        />
      </div>, document.getElementById('the-body'))

  );
}

export default Reveal;
